<div class="dark-mode">
    <div class="row my-3">
        <div class="col-12 col-sm-12 col-md-6">
            <h4 class="mt-3">Certification List</h4>
            <div style="color: #979797">Manage all your certifications in one place</div>
        </div>

        <div class="col-12 col-sm-12 col-md-6 text-end">
            <button (click)="checkAbilityToAddMore()" class="mt-3 bg-accent-orange" mat-raised-button aria-label="add certification" >
                <mat-icon>add</mat-icon> Add Certification
            </button>
        </div>
    </div>
    <div class="table-responsive-dark list-wrapper-bordered-dark">
        <table class="table table-striped table-hover table-bordered ">
            <thead>
            <tr>
                <th class="text-nowrap">Title</th>
                <th class="text-nowrap">Provider</th>
                <th class="text-nowrap">Date Earned</th>
                <th class="text-nowrap">Date Expired</th>
                <th class="text-nowrap">Attendance Type</th>
                <th class="text-nowrap">Certification ID</th>
                <th class="sticky-action"></th>
            </tr>
            </thead>
            <tbody>
            <tr *ngFor="let cert of userCerts">
                <td class="text-nowrap ellipsis">{{ cert.certification.certificationTitle }}</td>
                <td class="text-nowrap">{{ cert.certification?.association?.providerName }}</td>
                <td class="text-nowrap">{{ cert.acquiredDate | date : "MM/dd/y" }}</td>
                <td class="text-nowrap">{{ cert.expiresDate | date : "MM/dd/y" }}</td>
                <td class="text-nowrap">{{maskingColumn('parameterLabel', 'parameterValue', attendanceTypes.parameterMembers, cert.attendanceType)}}</td>
                <td class="text-nowrap">{{ cert.providerAssignedId }}</td>
                <td class="sticky-action" style="width: 80px;">
                    <div class="d-flex gap-4 justify-content-center">
                        <mat-icon class="accent-orange" (click)="updateCertification(cert)">edit</mat-icon>
                        <mat-icon class="crimson-red" (click)="deleteCertification(cert)">delete</mat-icon>
                    </div>
                </td>
            </tr>
            <tr *ngIf="userCerts.length == 0">
                <td colspan="7" class="text-center">
                    <span>No Certifications available </span>
                </td>
            </tr>
            </tbody>
        </table>
    </div>
    <div class="mt-4" *ngIf="userCerts.length > 0">
        <app-pagination-dark
                (goPage)="toPage($event)"
                (goPerPage)="perPageSet($event)"
                [pagesToShow]="showPages"
                [page]="pageNo"
                [perPage]="pageSize"
                [count]="totalRow"></app-pagination-dark>
    </div>
</div>

